import { Navigate, Route, Routes } from 'react-router';
import { Trans } from '@lingui/react/macro';

import { SettingsSectionLayout } from '../../../components/Layout/Layout';

import { Invitations } from './subsections/Invitations/Invitations';
import { RolesRoutes } from './subsections/Roles/Roles';
import { UsersRoutes } from './subsections/Users/Users';

export const Members = () => {
  return (
    <SettingsSectionLayout
      title={<Trans id="settings-section.team">Team</Trans>}
      tabs={[
        { id: 'users', label: <Trans id="settings.organization.members.users">Users</Trans> },
        {
          id: 'invitations',
          label: <Trans id="settings.organization.members.invitations">Invitations</Trans>,
        },
        { id: 'roles', label: <Trans id="settings.organization.members.roles">Roles</Trans> },
      ]}
    >
      <Routes>
        <Route path="" element={<Navigate to="/settings_beta/team/users" replace />} />
        <Route path="users/*" element={<UsersRoutes />} />
        <Route path="invitations" element={<Invitations />} />
        <Route path="roles/*" element={<RolesRoutes />} />
        <Route path="*" element={<Navigate to="/settings_beta/team" replace />} />
      </Routes>
    </SettingsSectionLayout>
  );
};
